import script from "./CyPropWatchingView.vue?vue&type=script&lang=js"
export * from "./CyPropWatchingView.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__